import fetch from 'auth/FetchInterceptor'

const ArticlesService = {}

// Articles.
ArticlesService.getArticles = function (params) {
	return fetch({
		url: '/articles',
		method: 'get',
		params,
	})
}

ArticlesService.saveArticleGallery = function (data) {
	return fetch({
		url: '/articles/order',
		method: 'post',
		data: data,
	})
}

ArticlesService.getArticle = function (articleId, params = {}) {
	return fetch({
		url: `/articles/single/${articleId}`,
		method: 'get',
		params,
	})
}

ArticlesService.addOrUpdateArticle = function (data) {
	return fetch({
		url: '/articles',
		method: 'post',
		data: data,
	})
}

ArticlesService.deleteArticle = function (articleId) {
	return fetch({
		url: `/articles/${articleId}`,
		method: 'delete',
	})
}

// Article categories.
ArticlesService.getArticleCategories = function (params) {
	return fetch({
		url: '/articles/categories',
		method: 'get',
		params,
	})
}

ArticlesService.addCategory = function (data) {
	return fetch({
		url: '/articles/categories',
		method: 'post',
		data: data,
	})
}

ArticlesService.updateCategory = function (data) {
	return fetch({
		url: '/articles/categories',
		method: 'put',
		data: data,
	})
}

ArticlesService.deleteCategory = function (id) {
	return fetch({
		url: `/articles/categories/${id}`,
		method: 'delete',
	})
}

// Article sections.
ArticlesService.getArticleSections = function (params = {}) {
	return fetch({
		url: '/settings/sections',
		method: 'get',
		params,
	})
}

// Article gallery.
ArticlesService.getArticleGallery = function () {
	return fetch({
		url: '/articles/gallery',
		method: 'get',
	})
}

// Side panel.
ArticlesService.saveSidePanelArticles = function (data) {
	return fetch({
		url: '/articles/side-panel',
		method: 'post',
		data: data,
	})
}

ArticlesService.getSidePanelArticles = function (params = {}) {
	return fetch({
		url: '/articles/side-panel',
		method: 'get',
		params,
	})
}

export default ArticlesService
